import React, { Fragment } from 'react';
import { Link } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  PORTAL_NEVER_ACTIVE,
  PORTAL_ACTIVE_NEVER_ONBOARDED,
  PORTAL_ACTIVE_AND_PROCESSING,
  PORTAL_ACTIVE_AND_ONBOARDED,
  PORTAL_DEACTIVATED_NEVER_ONBOARDED,
  PORTAL_DEACTIVATED_AND_ONBOARDED,
  STATIC_FILTERS,
} from './constants';

const AVAIL_URL = import.meta.env.REACT_APP_AVAILABILITY_URL || '';
const PORTAL_URL = import.meta.env.REACT_APP_PORTAL_URL || '';

export const determinePortalStatus = (property: Object) => {
  const {
    isResidentPortalActive,
    onboardingQueue,
    portalLatestOnboardingGroupId,
    portalLatestOnboardingById,
    portalUpdatedAt,
  } = property;
  if (
    !isResidentPortalActive &&
    !portalLatestOnboardingGroupId &&
    !portalUpdatedAt
  ) {
    return PORTAL_NEVER_ACTIVE;
  }
  if (
    isResidentPortalActive &&
    !portalLatestOnboardingGroupId &&
    portalLatestOnboardingById === null
  ) {
    return PORTAL_ACTIVE_NEVER_ONBOARDED;
  }
  if (
    isResidentPortalActive &&
    ((portalLatestOnboardingGroupId && onboardingQueue > 0) ||
      (!portalLatestOnboardingGroupId && portalLatestOnboardingById))
  ) {
    return PORTAL_ACTIVE_AND_PROCESSING;
  }
  if (isResidentPortalActive && portalLatestOnboardingGroupId) {
    return PORTAL_ACTIVE_AND_ONBOARDED;
  }
  if (
    !isResidentPortalActive &&
    !portalLatestOnboardingGroupId &&
    portalUpdatedAt
  ) {
    return PORTAL_DEACTIVATED_NEVER_ONBOARDED;
  }
  if (!isResidentPortalActive && portalLatestOnboardingGroupId) {
    return PORTAL_DEACTIVATED_AND_ONBOARDED;
  }
};

export const determinedPortalActiveColumn = (
  property: Object,
  handleEditPropertyPortal: Function,
) => {
  const { portalStatus } = property;
  if (portalStatus === PORTAL_ACTIVE_AND_PROCESSING) {
    return (
      <span className="tag status-tag status-tag--orange-light">
        In Process
      </span>
    );
  }
  return [PORTAL_ACTIVE_NEVER_ONBOARDED, PORTAL_ACTIVE_AND_ONBOARDED].includes(
    portalStatus,
  ) ? (
    <Link onClick={() => handleEditPropertyPortal(property)}>Yes</Link>
  ) : (
    <Link onClick={() => handleEditPropertyPortal(property)}>No</Link>
  );
};

export const determinedPortalActiveColumnString = (portalStatus: any) => {
  if (portalStatus === PORTAL_ACTIVE_AND_PROCESSING) {
    return 'In Process';
  }

  return [PORTAL_ACTIVE_NEVER_ONBOARDED, PORTAL_ACTIVE_AND_ONBOARDED].includes(
    portalStatus,
  )
    ? 'Yes'
    : 'No';
};

export const determineLinkColumn = (
  activePortal: boolean,
  orgPropUrl: string,
  contactUsWidget: boolean,
) => {
  if (activePortal) {
    return (
      <Fragment>
        <Link
          href={`${AVAIL_URL}${orgPropUrl}`}
          target="_blank"
          rel="noreferrer"
        >
          Availability
        </Link>{' '}
        /{' '}
        <Link
          href={`${PORTAL_URL}${orgPropUrl}`}
          target="_blank"
          rel="noreferrer"
        >
          Portal
        </Link>
        {contactUsWidget && (
          <>
            {' '}
            /{' '}
            <Link
              href={`${PORTAL_URL}${orgPropUrl}/contact-us`}
              target="_blank"
              rel="noreferrer"
            >
              Contact Us
            </Link>
          </>
        )}
      </Fragment>
    );
  }
  return <Link href={`${AVAIL_URL}${orgPropUrl}`}>Availability</Link>;
};

export const isPortalActive = (portalStatus: ?string) => {
  return [
    PORTAL_ACTIVE_NEVER_ONBOARDED,
    PORTAL_ACTIVE_AND_PROCESSING,
    PORTAL_ACTIVE_AND_ONBOARDED,
  ].includes(portalStatus);
};

export const determineLinkColumnString = (
  portalStatus: ?string,
  orgPropUrl: string,
) => {
  if (
    [
      PORTAL_ACTIVE_NEVER_ONBOARDED,
      PORTAL_ACTIVE_AND_PROCESSING,
      PORTAL_ACTIVE_AND_ONBOARDED,
    ].includes(portalStatus)
  ) {
    return `Availability: ${AVAIL_URL}${orgPropUrl}; Portal: ${PORTAL_URL}${orgPropUrl}`;
  }
  return `Availability: ${AVAIL_URL}${orgPropUrl}`;
};
export const getStreetAddress = (
  physicalStreetAddress1: string,
  physicalStreetAddress2: ?string,
) => {
  return [physicalStreetAddress1, physicalStreetAddress2]
    .filter(Boolean) // Physical Address 2 is optional
    .join(' ');
};

export const getFilters = (owners: Object) => [
  ...STATIC_FILTERS,
  {
    fieldName: 'ownerId',
    fieldDescription: 'Owner',
    options: owners.map((owner) => ({
      text: owner.name,
      value: owner.id,
    })),
  },
];

export const formatPhoneNumber = (phoneNumber: string) => {
  const cleanPhoneNumber = phoneNumber && phoneNumber.replace(/[^\d]/g, ''); // Remove all symbols from phone numbers
  return phoneNumber
    ? `(${cleanPhoneNumber.substr(0, 3)}) ${cleanPhoneNumber.substr(
        3,
        3,
      )}-${cleanPhoneNumber.substr(6, 4)}`
    : '---';
};

export const createAvailabilityLink = (orgPropUrl) => {
  return `${AVAIL_URL}${orgPropUrl}`;
};

export const createPortalLink = (orgPropUrl) => {
  return `${PORTAL_URL}${orgPropUrl}`;
};

export const createContactUsLink = (orgPropUrl) => {
  return `${PORTAL_URL}${orgPropUrl}/contact-us`;
};
